import React from "react";
import { HStack, Text } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";

/**
 * A clickable date group header for a fax list.
 *
 * The whole row is the control (not just the chevron) — these groups can hold
 * dozens of faxes and the header is what the user is already aiming at. The
 * count stays visible while collapsed, so a collapsed day still says how much
 * is inside.
 */
export default function FaxDateHeader({
  dateKey,
  count,
  noun,
  isCollapsed,
  onToggle,
  color = "blue.700",
  borderColor = "blue.200",
}) {
  return (
    <HStack
      as="button"
      type="button"
      onClick={() => onToggle(dateKey)}
      aria-expanded={!isCollapsed}
      aria-label={`${isCollapsed ? "Expand" : "Collapse"} ${dateKey}`}
      width="100%"
      spacing={2}
      mb={3}
      pb={2}
      borderBottom="2px solid"
      borderColor={borderColor}
      _hover={{ opacity: 0.75 }}
      cursor="pointer"
      textAlign="left"
    >
      {isCollapsed ? (
        <ChevronRightIcon color={color} boxSize={5} />
      ) : (
        <ChevronDownIcon color={color} boxSize={5} />
      )}
      <Text fontSize="lg" fontWeight="bold" color={color}>
        {dateKey} ({count} {noun})
      </Text>
    </HStack>
  );
}
